import { RootState } from "../..";

export const selectUser = (state: RootState) => state.auth.data;

export const selectIsAuthLoading = (state: RootState) => state.auth.isLoading;

export const selectIsOpenDashboard = (state: RootState) =>
  state.auth.openDashboard;
